// extracted by mini-css-extract-plugin
module.exports = {"machineIcon":"style_machineIcon__3-rQcwqA8SAWXxHo8warhI","machineImage":"style_machineImage__1Y6pOgfKaccKDuHkoADPa0"};